import React, { useState, useEffect, useContext } from 'react';
import { createPortal } from 'react-dom';
import { IComment } from './AllForCommentList';
import './GiftTransition.scss';
import { ThemeContext } from '../../store/ThemeProvider';
import intl from 'react-intl-universal';
import { alpha, getPendantColor } from '../../utils/color';
import { style } from '../../utils/image';

let giftList = [] as IComment[];

const GiftTransition = () => {
  const { mainColor, h1Color, componentColor } = useContext(ThemeContext);
  const [bgColor, foreColor] = getPendantColor(mainColor, true);

  const [list, setList] = useState([] as IComment[]);

  useEffect(() => {
    const clearLast = () => {
      giftList.shift();
      setList([...giftList]);
    };

    const onGiftMessage = (e: Event) => {
      let { data } = e;
      if (data) {
        giftList.push(data as IComment);
        let newList = [...giftList];
        setList(newList);
        setTimeout(clearLast, 5000);
      }
    };

    window.addEventListener('custom-comment-gift-transition', onGiftMessage);

    return () => {
      window.removeEventListener(
        'custom-comment-gift-transition',
        onGiftMessage
      );
    };
  }, []);

  return createPortal(
    <div className="gift-transition">
      <div className="wrapper">
        {(list || [])
          .map((it: IComment) => {
            const { avatar, nick_name, content } = it;
            let giftData = {} as {
              id: number;
              image: string;
              name: string;
              count: number;
            };
            try {
              giftData = JSON.parse(content);
              return (
                <div className="animate" key={it.id}>
                  <div
                    className="avatar"
                    style={{ borderColor: componentColor }}
                  >
                    <img
                      src={
                        avatar && avatar.indexOf('//') > -1
                          ? avatar
                          : style(avatar, 'avatar_150')
                      }
                    />
                  </div>
                  <div
                    className="bar"
                    style={{
                      color: bgColor,
                      background: `linear-gradient(90deg, ${mainColor} 0%, ${mainColor} 30%, transparent 100%)`
                    }}
                  >
                    <span className="nickname">{nick_name}</span>
                    <span className="intl">{intl.get('Give')}</span>
                    <div className="gift-image">
                      <img
                        src={
                          giftData && giftData.image
                            ? style(giftData.image, 'avatar_150')
                            : undefined
                        }
                      />
                    </div>
                    <div className="count" style={{ color: mainColor }}>
                      <span className="small" style={{ color: mainColor }}>
                        X
                      </span>
                      {giftData && giftData.count}
                    </div>
                  </div>
                </div>
              );
            } catch (e) {
              return null;
            }
          })
          .filter(Boolean)}
      </div>
    </div>,
    document.body
  );
};

export default GiftTransition;
